import React, { useContext, useState } from "react";
import * as styles from "./Header.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import Button from "../Button";
// import useOnline from "@app/lib/hooks/useOnline";
import Navi from "../Navi";
import { SaveInspectionContext } from "@app/components/SaveInspectionContextContainer/SaveInspectionContextContainer.jsx";
import { SignsOverlayContext } from "@app/components/SignsOverlayContext/SignsOverlayContext";
import { useNavigationConfig } from "@app/routes/root.jsx";

const Header = ({
	title,
	topTitle,
	onClickMenu,
	onClickSave,
	saveButtonEnable,
	/*showSaveButton = true,*/
	showNavi,
	className,
}) => {
	const headerClassName = classNames({
		[styles["header"]]: true,
		[styles["save-enable"]]: !!saveButtonEnable,
		"hide-on-print": true,
		[className]: !!className,
	});
	const [showNav, setShowNav] = useState(false);
	const { saveInspectionHandler } = useContext(SaveInspectionContext);
	const { signsOverlayHandler } = useContext(SignsOverlayContext);
	const navi = useNavigationConfig({ signsOverlayHandler });

	return (
		<div className={headerClassName}>
			{showNavi && (
				<>
					<div
						className={styles["burger"]}
						onClick={() => {
							setShowNav(!showNav);
							if (onClickMenu && typeof onClickMenu === "function") {
								onClickMenu();
							}
						}}
					>
						<div className={styles["burger-inner"]} />
					</div>
					<Navi
						title={navi.title}
						show={showNav}
						onClickClose={() => {
							setShowNav(false);
							if (navi.onClickClose && typeof navi.onClickClose === "function") {
								navi.onClickClose();
							}
						}}
						items={navi.items}
						meta={navi.meta}
					/>
				</>
			)}
			{topTitle && <span className={styles["top-title"]}>{topTitle}</span>}
			{title && <span className={styles["title"]}>{title}</span>}
			{/*{online ? <span className={styles.connectivity}>online</span> : <span>offline</span>}*/}
			{/*{inspection && <span className={styles.sync}>sync: {inspection.synced?.toString()}</span>}*/}
			<div
				className={styles["head-button-holder"]}
				onClick={() => {
					if (onClickSave && typeof onClickSave === "function") {
						onClickSave();
					}
				}}
			>
				{!!saveInspectionHandler && (
					<Button
						callback={() => saveInspectionHandler.fn()}
						iconBefore={"save"}
						iconSize={24}
						type={"tertiary"}
						big={true}
						disabled={!saveInspectionHandler.active}
					/>
				)}
			</div>
		</div>
	);
};

Header.propTypes = {
	title: PropTypes.string,
	onClickMenu: PropTypes.func,
	onClickSave: PropTypes.func,
	saveButtonEnable: PropTypes.bool,
	showSaveButton: PropTypes.bool,
	className: PropTypes.string,
	navi: PropTypes.shape({
		title: PropTypes.string,
		onClickClose: PropTypes.func,
		items: PropTypes.array.isRequired,
	}),
};

export default Header;
